











































import { Component, Vue } from 'vue-property-decorator'
import App from '../App.vue'

@Component
export default class Home extends App {}
